import { render } from "./transaction_settings.vue?vue&type=template&id=6d324d10&ts=true"
import script from "./transaction_settings.vue?vue&type=script&lang=ts"
export * from "./transaction_settings.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__